import {Component} from '@angular/core';
import { CommonModule } from '@angular/common';
import {CustomerService} from 'src/app/shared/services/customer.service';
import {VehicleBrand} from 'src/app/domain/core/vehicle-brand.model';
import {LegalEntity} from 'src/app/domain/core/legal-entity.model';
import {Country} from 'src/app/domain/core/country.model';
import {environment} from 'src/environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {ActivitySpinnerComponent} from 'src/app/shared/components/activity-spinner/activity-spinner.component';
import {AppState} from '../../shared/utils/AppState';
import {LoadingSpinnerComponent} from '../../shared/components/loading-spinner/loading-spinner.component';

@Component({
    selector: 'app-doi',
    templateUrl: './doi.component.html',
  imports: [CommonModule, ActivitySpinnerComponent, LoadingSpinnerComponent]
})
export class DoiComponent {
  legalEntity: LegalEntity = LegalEntity.ToyotaGermany
  verificationToken: string;
  loading = true;
  done = false;
  success = false;
  denyExtendConsent = false;
  confirmExtendConsent = false;
  denyPreferredDealer = false;
  confirmPreferredDealer = false;
  confirmInProgress = false;
  denyInProgress = false;

  constructor(
    private customerService: CustomerService,
    private route: ActivatedRoute,
    private router: Router
    ) {
    this.route.queryParams.subscribe(params => {
      this.denyExtendConsent = (params['action'] === 'denyExtendConsent');
      this.confirmExtendConsent = (params['action'] === 'confirmExtendConsent');
      this.denyPreferredDealer = (params['action'] === 'denyPreferredDealer');
      this.confirmPreferredDealer = (params['action'] === 'confirmPreferredDealer');
    })
    this.route.params.subscribe(params => {
      const brand = VehicleBrand.from(params['brand'])
      this.legalEntity = LegalEntity.from(brand, Country.from(environment.country))
      AppState.shared.setLegalEntity(this.legalEntity)
      console.log(
        'brand', brand,
        'country', Country.from(environment.country),
        'legalEntity', this.legalEntity,
        'environment.country', environment.country,
        'AppState.shared.legalEntity', AppState.shared.legalEntity,
      )
      this.verificationToken = params['verificationtoken'];
      this.customerService.checkVerificationToken(this.verificationToken).subscribe({
        next: (response) => {
          this.loading = false;
        },
        error: (error) => {
          console.log('invalid verification token', error);
          this.router.navigate(['error']);
        }
      });
    })
  }

  get inProgress():boolean {
    return (this.denyInProgress || this.confirmInProgress);
  }

  confirm() {
    this.confirmInProgress = true;
    this.customerService
      .confirmCustomerConsent(this.legalEntity.vehicleBrand, this.verificationToken)
      .subscribe((success) => {
        this.success = success;
        this.done = true;
        this.confirmInProgress = false;
      });
  }

  deny() {
    this.denyInProgress = true;
    this.customerService
      .denyCustomerConsent(this.legalEntity.vehicleBrand, this.verificationToken)
      .subscribe((success) => {
        this.denyInProgress = false;
        this.success = success;
        this.done = true;
      });
  }
}
